import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=20210180&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=20210180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20210180",
  null
  
)

export default component.exports